var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "body",
      {
        staticClass:
          "home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container",
        staticStyle: { "overflow-y": "unset", "background-color": "#f5f7f7" },
        attrs: { "data-anchor": "pagetop" }
      },
      [
        _c("navbar", {
          attrs: {
            follow: "st-Header",
            imgSrc: "../../../../static/img/logo/logo-black.png"
          }
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("copyright")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "st-MainContainer col-12" }, [
      _c(
        "main",
        {
          staticClass: "st-MainContents",
          staticStyle: { "padding-top": "120px" }
        },
        [
          _c("header", { staticClass: "news-PageTitle" }, [
            _c("div", { staticClass: "news-PageTitle_Inner" }, [
              _c(
                "h1",
                {
                  staticClass: "sw-Section_Header appear",
                  attrs: { "data-appear": "" }
                },
                [
                  _c("span", { staticClass: "sw-Section_Header-en mt-2" }, [
                    _c("b", [_vm._v("PRIVACY POLICY")])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "sw-Section_Header-ja" }, [
                    _c("b", [_vm._v("プライバシーポリシー")])
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "policy-Block" }, [
            _c("div", { staticClass: "policy-Block_Inner" }, [
              _c("div", [
                _c("p", [
                  _vm._v(
                    "株式会社ロボティクスソリューションズは、個人情報保護の重要性に鑑み、以下のとおりプライバシーポリシーを定めています。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("h2", [_vm._v("個人情報保護体制の確立")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "当社は、役員及び従業員に個人情報保護の重要性を認識させ、個人情報を適切に保護するための体制を確立します。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("h2", [_vm._v("個人情報の取得・利用・提供等")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "当社は、当社における個人情報の取得、利用、提供等に関して諸規則を策定し、これに基づき個人情報を適切に取り扱います。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("h2", [_vm._v("安全管理措置")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "当社は、個人情報の正確性及び安全性を確保するため、情報セキュリティ対策をはじめとする安全管理措置を講じ、個人情報への不正アクセス、または個人情報の紛失、破壊、改ざん、漏えい等の予防に努めます。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("h2", [_vm._v("情報主体の権利尊重")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "当社は、個人情報に関する情報主体の権利を尊重し、ご本人から自己情報の開示、内容の訂正、追加または削除、消去及び第三者への提供の停止を求められたときは、法令の定めに従いこれに応じます。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("h2", [_vm._v("法令の遵守")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "当社は、個人情報の取扱いにおいて個人情報の保護に関する法律及び関連する政省令並びにその他のガイドラインを遵守します。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("h2", [_vm._v("利用目的について")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "当社は、お客様の住所、氏名等の個人情報（お客様と当社との取引に関する情報を含み、以下「個人情報」といいます。）を下記の目的で利用いたします。なお、当社は、あらかじめお客様ご本人の同意を得ることなく、下記目的以外にお客様の個人情報を利用することはありません。"
                  )
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "当社が取扱う商品・サービス等について、または各種イベント・キャンペーン等の開催について、宣伝印刷物の送付、電話、電子メールの送信等によりご案内すること。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "商品開発またはお客様満足度向上策等の検討のために、アンケート調査を実施すること。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "お客様の個人情報を書面または電子媒体により下記の第三者に提供する事。但し、お客様ご本人のお申出があった場合、第三者提供を停止いたします。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "採用に関する各種連絡・お知らせの配信。提供先：当社の関連会社並びに当社。但し、ウェブサイト、書面等により、別途の利用目的が公表されている場合、または取得に当たり、お客様に利用目的を明示した場合においては、その利用目的が優先されるものとします。"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("h2", [_vm._v("個人情報の開示、訂正等について")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "当社は、個人情報の保護に関する法律に基づき、当社が保有する個人情報に関して、お客様ご本人から開示、訂正等のご請求があった場合には、適切に対応いたします。開示、訂正等のご請求方法につきましては、以下のとおりとします。"
                  )
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v("当ウェブサイトのお問い合わせ窓口にご連絡ください。")
                  ])
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "st-Breadcrumbs" }, [
        _c(
          "ul",
          {
            staticClass: "st-BreadcrumbsList",
            attrs: { itemscope: "itemscope", itemtype: "" }
          },
          [
            _c(
              "li",
              {
                staticClass: "st-BreadcrumbsList_Item",
                attrs: {
                  itemprop: "itemListElement",
                  itemscope: "itemscope",
                  itemtype: ""
                }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "st-BreadcrumbsList_Item-link",
                    attrs: { href: "/", itemprop: "item" }
                  },
                  [_vm._v("ホーム")]
                ),
                _vm._v(" "),
                _c("meta", { attrs: { itemprop: "position", content: "1" } })
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "st-BreadcrumbsList_Item",
                attrs: {
                  itemprop: "itemListElement",
                  itemscope: "itemscope",
                  itemtype: ""
                }
              },
              [
                _c(
                  "p",
                  {
                    staticStyle: { "margin-bottom": "0rem" },
                    attrs: { itemprop: "item", "aria-current": "page" }
                  },
                  [
                    _c("span", { attrs: { itemprop: "name" } }, [
                      _vm._v("プライバシーポリシー")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("meta", { attrs: { itemprop: "position", content: "3" } })
              ]
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3369634", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3369634","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/policy/privacy.vue
// module id = null
// module chunks = 